import moment from 'moment'
import MediaEntity, { IMediaProps } from './Media'
import { toMediaProps } from '@/gateways/Upstream/translator/media'

export interface INewsProps {
  id?: string
  title: any
  description: any
  views: number
  category: string | null
  properties: any
  favoritesCount: number
  likes: number
  publishedAt: string | null
  createdAt: string | null
  updatedAt: string | null
  files?: any
  path: string
  modelType: string
}

export interface INewsQueryProps {
  category: number
}

export default class NewsEntity {
  private _props: INewsProps

  constructor(props?: INewsProps | null) {
    this._props = EmptyNewsPropsFactory(props)
  }

  get props(): INewsProps {
    return this._props
  }

  get clone(): INewsProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get title(): any {
    const sub = this._props.properties.series ? ' - ' + this._props.properties.series + ' 第' + this._props.properties.number + '回' : ''
    return this._props.title?.ja + sub
  }

  get description(): any {
    return this._props.description.ja
  }

  get media(): IMediaProps[] {
    return this._props.properties.media.length > 0 ? this._props.properties.media.map((prop: any) => toMediaProps(prop)) : []
  }

  get thumbnail(): string {
    // アップロードしたサムネイルファイルがあるかチェック
    if (this.media.length > 0) {
      const media = new MediaEntity(this.media[0])
      return media.src!
    }
    return this._props.properties.thumbnail
  }

  get publishedAt(): string | null {
    return moment(this._props.publishedAt).format('YYYY年M月D日')
  }

  get deliveredAt(): string | null {
    return moment(this._props.properties.deliveredAt).format('YYYY年M月D日 HH:mm')
  }

  get createdAt(): string | null {
    return moment(this._props.createdAt).format('YYYY年M月D日 HH:mm')
  }

  get updatedAt(): string | null {
    return moment(this._props.updatedAt).format('YYYY年M月D日 HH:mm')
  }

  get arrival(): boolean {
    return moment().isBefore(moment(this._props.publishedAt).add(8, 'd'))
  }
}

export const tabs = ['最新', '特集/連載', '外科ニュース']

export const EmptyNewsPropsFactory = (props?: Partial<INewsProps> | null): INewsProps => ({
  title: {},
  description: {},
  views: 0,
  category: null,
  properties: {},
  publishedAt: null,
  favoritesCount: 0,
  likes: 0,
  createdAt: null,
  updatedAt: null,
  path: 'news',
  modelType: 'App\\Models\\News',
  ...props
})
